var map = {
	"./anim/Worm-cta.svg": 20,
	"./anim/Worm-intro.svg": 21,
	"./anim/Worm-long.svg": 22,
	"./anim/Worm.svg": 23,
	"./icon-arrow-down.svg": 24,
	"./icon-arrow-left-long.svg": 25,
	"./icon-arrow-left.svg": 26,
	"./icon-arrow-right-long.svg": 27,
	"./icon-arrow-right.svg": 28,
	"./icon-arrow-up-large.svg": 29,
	"./icon-arrow-up.svg": 30,
	"./icon-close.svg": 31,
	"./icon-email.svg": 32,
	"./icon-facebook.svg": 33,
	"./icon-hart.svg": 34,
	"./icon-instagram.svg": 35,
	"./icon-levelup-badge.svg": 36,
	"./icon-linkedin.svg": 37,
	"./icon-mail.svg": 38,
	"./icon-marker.svg": 39,
	"./icon-menu.svg": 40,
	"./icon-messenger.svg": 41,
	"./icon-phone.svg": 42,
	"./icon-pinterest.svg": 43,
	"./icon-play.svg": 44,
	"./icon-plus.svg": 45,
	"./icon-quote.svg": 46,
	"./icon-read-more.svg": 47,
	"./icon-search.svg": 48,
	"./icon-skype.svg": 49,
	"./icon-snapchat.svg": 50,
	"./icon-star.svg": 51,
	"./icon-telegram.svg": 52,
	"./icon-tiktok.svg": 53,
	"./icon-twitter.svg": 54,
	"./icon-vimeo.svg": 55,
	"./icon-whatsapp.svg": 56,
	"./icon-world.svg": 57,
	"./icon-youtube.svg": 58,
	"./icons/icon-arrow-up.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;